import { Link } from '@backstage/core-components';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';

type ActionableProps = {
  children: React.ReactNode;
  cardProps: {
    actionable: boolean;
    actionRoute?: string;
    target?: string;
  };
  style: React.CSSProperties;
};

export const CardActionable = ({
  children,
  cardProps,
  style,
}: ActionableProps) => {
  return cardProps.actionable && cardProps.actionRoute ? (
    <CardActionArea
      component={Link}
      to={cardProps.actionRoute}
      target={cardProps.target}
      color="inherit"
      underline="none"
      style={{ flexGrow: 1, alignItems: 'baseline' }}
    >
      <CardContent style={style}>{children}</CardContent>
    </CardActionArea>
  ) : (
    <>{children}</>
  );
};
